type PropsType = {
  styles?: object;
  fill?: string;
  stroke?: string;
  outline?: boolean;
};

const LocationIcon = ({ styles, fill, stroke, outline }: PropsType) => {
  return outline ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill={fill || 'none'}
      {...(styles && { style: styles })}
    >
      <path
        d="M9 10.3068C10.2426 10.3068 11.25 9.2994 11.25 8.05676C11.25 6.81412 10.2426 5.80676 9 5.80676C7.75736 5.80676 6.75 6.81412 6.75 8.05676C6.75 9.2994 7.75736 10.3068 9 10.3068Z"
        stroke={stroke || 'white'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 17.4318C10.5 14.4318 15 12.4955 15 8.43176C15 5.11805 12.3137 2.43176 9 2.43176C5.68629 2.43176 3 5.11805 3 8.43176C3 12.4955 7.5 14.4318 9 17.4318Z"
        stroke={stroke || 'white'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="16"
      height="15"
      viewBox="0 0 17 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
      style={styles}
    >
      <path
        d="M8.39851 23.957C8.45838 23.957 8.52286 23.957 8.58274 23.957C8.62419 23.9022 8.66564 23.8519 8.70248 23.7971C10.9731 20.6867 13.1055 17.4894 14.8694 14.0592C15.5004 12.8351 16.0577 11.5836 16.4123 10.2499C16.5321 9.79769 16.5827 9.32723 16.6656 8.87048C16.6656 8.76543 16.6656 8.65581 16.6656 8.55075C16.6334 8.2493 16.6104 7.94784 16.5689 7.65095C16.2742 5.54989 15.307 3.8051 13.6582 2.47138C11.8067 0.964101 9.66967 0.388594 7.29316 0.717455C6.03581 0.891021 4.88901 1.34777 3.85274 2.06944C2.36511 3.1017 1.31963 4.47653 0.74853 6.18935C0.306387 7.52306 0.177429 8.88418 0.568911 10.2636C0.941967 11.5836 1.48543 12.8351 2.1118 14.0546C3.9034 17.5442 6.07726 20.7963 8.39851 23.957ZM8.48141 11.6156C6.86944 11.611 5.55683 10.3001 5.56604 8.71062C5.57525 7.11198 6.89246 5.81481 8.49984 5.81938C10.1026 5.82394 11.429 7.14396 11.4152 8.72889C11.406 10.3275 10.0934 11.6201 8.48141 11.6156Z"
        fill={fill || '#fffff'}
      />
    </svg>
  );
};

export default LocationIcon;
